module.exports = __webpack_public_path__ + "./img/2.83b91dd8.png";